import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { Spinner } from 'react-bootstrap';
import { apiAction, generalSet } from '../../store/generalSlice';
import { parseJSON } from '../../utils/helpers';
import ObjectViewer from '../Common/ObjectViewer';

const Log = () => {
  const dispatch = useDispatch();
  const { log_id } = useParams();

  const {
    log,
    checkBudgets,
    checkTodaySpends,
    checkYesterdaySpends,
    checkSedoRevenueToday,
    changeDailyBudgerBy1Amount,
  } = useSelector((state) => state.general);

  const [checkBudgetClicked, setCheckBudgetClicked] = useState(false);
  const [checkTodaySpendClicked, setCheckTodaySpendClicked] = useState(false);
  const [checkYesterdaySpendClicked, setCheckYesterdaySpendClicked] = useState(false);
  const [checkSedoRevenueClicked, setCheckSedoRevenueClicked] = useState(false);
  const [changeDailyBudgerBy1AmountClicked, setChangeDailyBudgerBy1AmountClicked] = useState(false);

  useEffect(() => {
    dispatch(apiAction({ reduxField: 'log', route: 'logs/getLogById', id: log_id }));
  }, []);

  if (log?._id !== log_id) {
    dispatch(generalSet({ reduxField: 'log', value: null }));
  }

  console.log({ log, checkBudgets, checkTodaySpends, checkSedoRevenueToday, changeDailyBudgerBy1Amount });
  return log?._id ? (
    <div>
      {(() => {
        const data = parseJSON(log.jsonData);
        const createdAt = new Date(log.createdAt).toLocaleString();

        console.log({ data });
        const passedChackerResultsColumns = [
          {
            field: 'sentence',
            headerName: 'Sentence',
            width: 200,
          },
          {
            field: 'calculatedSentence',
            headerName: 'Calculated Sentence',
            width: 200,
            renderCell: (params) => (
              <span style={{ color: params.value ? 'green' : 'red' }}>{params.value?.toString()}</span>
            ),
          },
          {
            field: 'checkBudgets',
            headerName: 'Check Current Budgets',
            width: 200,
            renderCell: (params) =>
              checkBudgets?.id === params.row.id ? (
                <>
                  Adset: {checkBudgets.adsetDailyBudget} | Campaign: {checkBudgets.campaignDailyBudget}
                </>
              ) : (
                <>
                  <button
                    className='btn btn-sm btn-outline-primary'
                    disabled={checkBudgetClicked === params.row.id}
                    onClick={() => {
                      dispatch(
                        apiAction({
                          reduxField: 'checkBudgets',
                          route: 'operations/checkBudgets',
                          accountId: params.row.account_id,
                          campaignId: params.row.campaign_id,
                          adsetId: params.row.adset_id,
                          id: params.row.id,
                        })
                      );
                      setCheckBudgetClicked(params.row.id);
                    }}
                  >
                    Check
                  </button>
                </>
              ),
          },

          {
            field: 'checkTodaySpends',
            headerName: 'Check Today Spends',
            width: 200,
            renderCell: (params) =>
              checkTodaySpends?.id === params.row.id ? (
                <>
                  Adset: {checkTodaySpends.campaignSpend} | Campaign: {checkTodaySpends.adsetSpend}
                </>
              ) : (
                <>
                  <button
                    className='btn btn-sm btn-outline-primary'
                    disabled={checkTodaySpendClicked === params.row.id}
                    onClick={() => {
                      dispatch(
                        apiAction({
                          reduxField: 'checkTodaySpends',
                          route: 'operations/checkSpends',
                          accountId: params.row.account_id,
                          campaignId: params.row.campaign_id,
                          adsetId: params.row.adset_id,
                          datePreset: 'today',
                          id: params.row.id,
                        })
                      );
                      setCheckTodaySpendClicked(params.row.id);
                    }}
                  >
                    Check
                  </button>
                </>
              ),
          },

          {
            field: 'checkYesterdaySpends',
            headerName: 'Check Yesterday Spends',
            width: 200,
            renderCell: (params) =>
              checkYesterdaySpends?.id === params.row.id ? (
                <>
                  Adset: {checkYesterdaySpends.campaignSpend} | Campaign: {checkYesterdaySpends.adsetSpend}
                </>
              ) : (
                <>
                  <button
                    className='btn btn-sm btn-outline-primary'
                    disabled={checkYesterdaySpendClicked === params.row.id}
                    onClick={() => {
                      dispatch(
                        apiAction({
                          reduxField: 'checkYesterdaySpends',
                          route: 'operations/checkSpends',
                          accountId: params.row.account_id,
                          campaignId: params.row.campaign_id,
                          adsetId: params.row.adset_id,
                          datePreset: 'yesterday',
                          id: params.row.id,
                        })
                      );
                      setCheckYesterdaySpendClicked(params.row.id);
                    }}
                  >
                    Check
                  </button>
                </>
              ),
          },

          // SEDO REVENUE
          {
            field: 'checkSedoRevenueToday',
            headerName: 'Check Sedo Revenue Today',
            width: 200,
            renderCell: (params) => {
              if (checkSedoRevenueToday?.id === params.row.id) {
                const summedRevenue = checkSedoRevenueToday?.result?.reduce(
                  (sum, campaign) => sum + parseFloat(campaign.revenue || 0),
                  0
                );
                return <>{summedRevenue}</>;
              }

              return (
                <>
                  <button
                    className='btn btn-sm btn-outline-primary'
                    disabled={checkSedoRevenueClicked === params.row.id}
                    onClick={() => {
                      dispatch(
                        apiAction({
                          reduxField: 'checkSedoRevenueToday',
                          route: 'operations/getSedoRevenue',
                          accountId: params.row.account_id,
                          startDate: new Date().toISOString().split('T')[0],
                          endDate: new Date().toISOString().split('T')[0],
                          id: params.row.id,
                        })
                      );
                      setCheckSedoRevenueClicked(params.row.id);
                    }}
                  >
                    Check
                  </button>
                </>
              );
            },
          },

          // Change Facebook Daily Budget
          {
            field: 'changeFacebookDailyBudget',
            headerName: 'Change Budget Test',
            width: 200,
            renderCell: (params) => {
              if (changeDailyBudgerBy1Amount?.id === params.row.id) {
                return <>Something</>;
              }

              return (
                <>
                  <button
                    className='btn btn-sm btn-outline-primary'
                    disabled={changeDailyBudgerBy1AmountClicked === params.row.id}
                    onClick={() => {
                      dispatch(
                        apiAction({
                          reduxField: 'changeDailyBudgerBy1Amount',
                          route: 'operations/changeDailyBudgerBy1Amount',
                          accountId: params.row.account_id,
                          campaignId: params.row.campaign_id,
                          adsetId: params.row.adset_id,
                          id: params.row.id,
                        })
                      );
                      setChangeDailyBudgerBy1AmountClicked(params.row.id);
                    }}
                  >
                    Check
                  </button>
                </>
              );
            },
          },

          ...Object.keys(
            Array.isArray(data?.passedChackerResults) && data.passedChackerResults[0]
              ? data?.passedChackerResults[0]
              : {}
          )
            .filter((key) => key !== 'sentence' && key !== 'calculatedSentence')
            .map((key) => ({
              field: key,
              headerName: key.replace(/_/g, ' ').toUpperCase(),
              width: 150,
            })),
        ];
        const passedChackerResultsEntries = Object.entries(
          Array.isArray(data?.passedChackerResults) && data.passedChackerResults[0] ? data?.passedChackerResults[0] : {}
        );
        return (
          <>
            <div className='border p-2' data-aos='fade-up' data-aos-delay='200'>
              <div className='row d-flex justify-content-center pt-lg-0'>
                <div className='col-lg-12 d-flex justify-content-center pt-lg-0'>
                  <h6 className='text-primary'>{log.logType}</h6>
                </div>
              </div>
              <div>
                <ObjectViewer data={data} />
              </div>
              <div className='row d-flex justify-content-center pt-lg-0'>
                <div className='col-lg-12 d-flex justify-content-center pt-lg-0 '>
                  <h6>{createdAt}</h6>
                </div>
              </div>
            </div>
            <div className='border p-2' data-aos='fade-up' data-aos-delay='200'>
              <Box style={{ height: 400, width: '100%' }}>
                <DataGrid
                  rows={passedChackerResultsEntries.map((entry, i) => ({ id: i, ...entry[1] })) || []}
                  columns={passedChackerResultsColumns}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  //   checkboxSelection
                  disableSelectionOnClick
                />
              </Box>
            </div>
          </>
        );
      })()}
    </div>
  ) : (
    <Spinner />
  );
};

export default Log;
